import * as R from 'ramda';
import moment from 'moment';


export default function SRReportScheduleController(
  $q,
  $rootScope,
  ssDialogService,
  alerts,
  confirmDialog,
  reportsDataService,
  orgDataService,
  srEditReportScheduleDialog,
  loaderService
) {
  const vm = this;

  vm.handleEditSchedule = _handleEditSchedule;
  vm.handleDeleteSchedule = _handleDeleteSchedule;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  /** ********************************************
   * Event Handlers
   */

  function _handleEditSchedule($event) {
    const dfdActivate = $q.defer();
    loaderService.showViewLoader = true;

    const getScheduledReport = reportsDataService.getScheduledReport(vm.reportSchedule.reportGroupId);
    const getReportRecipients = orgDataService.getReportRecipients();
    const getSchedule = reportsDataService.getSchedule(vm.reportSchedule.customerScheduleId);

    $q.all([
      getSchedule,
      getReportRecipients,
      getScheduledReport,
    ]).then((response) => {
      vm.appIsLoaded = true;
      const schedule = response[0].data;
      const scheduleObj = JSON.parse(response[0].data.parameters);

      schedule.report = response[2].data;
      schedule.schedule = {
        scheduleType: scheduleObj.scheduleParameters.scheduleType,
        executionHour: scheduleObj.scheduleParameters.hour,
        executionMinute: scheduleObj.scheduleParameters.minute,
        executionAMPM: scheduleObj.scheduleParameters.ampm,
        weeklyInterval: scheduleObj.scheduleParameters.weeklyInterval,
        weeklySunday: scheduleObj.scheduleParameters.weeklySunday,
        weeklyMonday: scheduleObj.scheduleParameters.weeklyMonday,
        weeklyTuesday: scheduleObj.scheduleParameters.weeklyTuesday,
        weeklyWednesday: scheduleObj.scheduleParameters.weeklyWednesday,
        weeklyThursday: scheduleObj.scheduleParameters.weeklyThursday,
        weeklyFriday: scheduleObj.scheduleParameters.weeklyFriday,
        weeklySaturday: scheduleObj.scheduleParameters.weeklySaturday,
        monthlyDayOfMonth: scheduleObj.scheduleParameters.monthlyDayOfMonth,
        recurranceType: scheduleObj.scheduleParameters.recurranceType,
      };
      if (!R.isNil(scheduleObj.scheduleParameters.onceExecutionDate)) {
        schedule.schedule.executionDate = moment(scheduleObj.scheduleParameters.executionDate);
      }
      if (!R.isNil(scheduleObj.scheduleParameters.rangeStartDate)) {
        schedule.schedule.rangeStartDate = moment(scheduleObj.scheduleParameters.rangeStartDate);
      }
      if (!R.isNil(scheduleObj.scheduleParameters.rangeEndDate)) {
        schedule.schedule.rangeEndDate = moment(scheduleObj.scheduleParameters.rangeEndDate);
      }
      R.forEach((submissionParameter) => {
        if (response[2].data.hasScheduleParameters) {
          R.forEach((scheduleParameter) => {
            if (submissionParameter.parameterName === scheduleParameter.parameterName) {
              // eslint-disable-next-line max-len
              schedule.schedule[`parameter${scheduleParameter.scheduleParameterId}Value`] = submissionParameter.parameterValue;
            }
          }, response[2].data.scheduleParameters);
        }
      }, schedule.submissionParameters);
      ssDialogService.dialogs.reports.editReportScheduleDialog = ssDialogService.alert(
        srEditReportScheduleDialog.getOptions($event, {
          schedule,
          reportRecipients: response[1].data.result,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.reports.editReportScheduleDialog);
      loaderService.showViewLoader = false;
      dfdActivate.resolve();
    });

    return dfdActivate.promise;
  }

  function _handleDeleteSchedule($event) {
    ssDialogService.dialogs.reports.deleteScheduleConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Schedule?',
        message: `Are you sure you want to delete schedule "${vm.reportSchedule.scheduleName}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.deleteScheduleConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return reportsDataService.deleteSchedule(vm.reportSchedule.customerScheduleId)
      .then(() => {
        alerts.success('The schedule has been deleted successfully.');
        $rootScope.$broadcast('reports.reportScheduleDeleted', { reportGroupId: vm.reportSchedule.reportGroupId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while deleting the schedule.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  /** ********************************************
   * Private Functions
   */

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.deleteScheduleConfirmDialog);
  }
}

SRReportScheduleController.$inject = [
  '$q',
  '$rootScope',
  'ssDialogService',
  'alerts',
  'confirmDialog',
  'reportsDataService',
  'orgDataService',
  'editReportScheduleDialog',
  'loaderService'
];
